module.exports = __webpack_public_path__ + "static/media/8400.81c5c7c7.jpg";